var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1422 9.31563L11.5797 6.06563C11.533 6.00629 11.4734 5.95832 11.4055 5.92531C11.3375 5.89229 11.263 5.87509 11.1875 5.875H10.175C10.0703 5.875 10.0125 5.99531 10.0766 6.07812L12.3313 8.9375H2.875C2.80625 8.9375 2.75 8.99375 2.75 9.0625V10C2.75 10.0687 2.80625 10.125 2.875 10.125H13.7484C14.1672 10.125 14.4 9.64375 14.1422 9.31563Z",
    fill: "#C1C1C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapRight);
export default __webpack_public_path__ + "static/media/swapRight.ef2cb1961c20f49bf4c92a3e66088865.svg";
export { ForwardRef as ReactComponent };